import { render, staticRenderFns } from "./SearchLegacy.vue?vue&type=template&id=3ad561e1&"
import script from "./SearchLegacy.vue?vue&type=script&lang=ts&"
export * from "./SearchLegacy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports